// faq-accordion.js
class FAQAccordion {
  constructor() {
    this.headers = document.querySelectorAll('.accordion-header');
    this.init();
  }

  // Function to set proper max-height
  setMaxHeight(content) {
    // Reset max-height to get actual scrollHeight
    content.style.maxHeight = 'none';
    // Force a reflow to ensure accurate measurement
    content.offsetHeight;
    // Set the max-height based on scrollHeight with some buffer
    const height = content.scrollHeight;
    content.style.maxHeight = height + 20 + 'px'; // Adding 20px buffer
  }

  // Initialize the accordion
  init() {
    this.setupInitialState();
    this.bindEvents();
    this.handleFontLoading();
  }

  // Set initial state for first item if enabled
  setupInitialState() {
    const firstContent = document.querySelector('.accordion-content.show');
    if (firstContent) {
      // Use setTimeout to ensure content is fully rendered
      setTimeout(() => {
        this.setMaxHeight(firstContent);
      }, 10);
    }
  }

  // Bind click events to headers
  bindEvents() {
    this.headers.forEach(header => {
      header.addEventListener('click', () => {
        this.handleAccordionClick(header);
      });
    });

    // Handle window resize - recalculate heights for open items
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        document.querySelectorAll('.accordion-content.show').forEach(content => {
          this.setMaxHeight(content);
        });
      }, 100);
    });
  }

  // Handle accordion header click
  handleAccordionClick(header) {
    const content = header.nextElementSibling;
    const isCurrentlyOpen = content.classList.contains('show');

    // Close all other content
    document.querySelectorAll('.accordion-content').forEach(otherContent => {
      if (otherContent !== content) {
        otherContent.style.maxHeight = '0px';
        otherContent.classList.remove('show');
        otherContent.previousElementSibling.classList.remove('active');
      }
    });

    // Toggle current content
    if (isCurrentlyOpen) {
      // Close current content
      content.style.maxHeight = '0px';
      content.classList.remove('show');
      header.classList.remove('active');
    } else {
      // Open current content
      content.classList.add('show');
      header.classList.add('active');
      
      // Use setTimeout to ensure content is visible before measuring
      setTimeout(() => {
        this.setMaxHeight(content);
      }, 10);
    }
  }

  // Handle font loading - recalculate heights if fonts change layout
  handleFontLoading() {
    if (document.fonts) {
      document.fonts.ready.then(() => {
        document.querySelectorAll('.accordion-content.show').forEach(content => {
          this.setMaxHeight(content);
        });
      });
    }
  }
}

// Initialize FAQ Accordion when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new FAQAccordion();
});